import React from "react";
import { FormSpy } from "react-final-form";
import { diff } from "deep-object-diff";

class AutoSave extends React.Component {
  constructor(props) {
    super(props);
    this.state = { submitting: false };
  }

  componentDidUpdate(nextProps) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    // console.log('componentWillReceiveProps componentWillReceiveProps')
    this.timeout = setTimeout(this.save, this.props.debounce);
  }

  save = async () => {
    if (this.promise) {
      await this.promise;
    }
    const { values, save, form } = this.props;
    const { initialValues, errors } = form.getState();
    // Diff against what the form was last initialized with: the specimen as the
    // sidebar holds it, which every save re-initializes the form to. So only
    // what the user changed since counts, and a form they have not touched has
    // nothing to save. Diffing against a snapshot kept here instead - taken at
    // construction, before the initial values arrived - saved the unchanged
    // specimen after every mount, switch and refresh. Each such save
    // re-initializes the form from the snapshot it took, wiping keys typed in
    // the meantime, and uploaded untouched fields as empty values. Its `id`
    // also made the user's first change look like a switch of specimen, which
    // the save handlers in Specimen.js and EnlargedSpecimen.js do not upload.
    let difference = diff(initialValues || {}, values);
    if (difference && difference["tags"]) {
      difference["tags"] = values["tags"];
    }
    if (
      difference &&
      Object.keys(difference).length &&
      Object.keys(errors || {}).length === 0
    ) {
      // values have changed
      this.setState({ submitting: true });
      this.promise = save(values, difference);
      await this.promise;
      delete this.promise;
      this.setState({ submitting: false });
    }
  };

  render() {
    // This component doesn't have to render anything, but it can render
    // submitting state.
    return (
      this.state.submitting && <div className="submitting">Submitting...</div>
    );
  }
}

// Make a HOC
// This is not the only way to accomplish auto-save, but it does let us:
// - Use built-in React lifecycle methods to listen for changes
// - Maintain state of when we are submitting
// - Render a message when submitting
// - Pass in debounce and save props nicely
//eslint-disable-next-line
export default (props) => (
  <FormSpy {...props} subscription={{ values: true }} component={AutoSave} />
);
